export const getFileNameFromUrl = (url: string | File) => {
  if (typeof url === 'string') {
    // @ts-ignore
    return decodeURI(url?.split('/')?.pop()?.split('?')?.shift())
  }
  return url.name
}

export const hasAll = (a: string[], b: string[]) => {
  const hash = a.reduce((acc, i) => {
    // @ts-ignore
    acc[i] = true
    return acc
  }, {})
  return b.every((item) => item in hash)
}

export type TDisplayRequirements = {
  clientVersions: { platform: string; minValue: string }[]
} | null

const IOS_PLATFORM = 'ios_app'
const ANDROID_PLATFORM = 'android_app'

const getMinVersion = (
  displayRequirements: TDisplayRequirements | undefined,
  platform: string,
) =>
  displayRequirements?.clientVersions?.find(
    (clientVersion) => clientVersion.platform === platform,
  )?.minValue ?? ''

export const getMinVersions = (
  displayRequirements: TDisplayRequirements | undefined,
) => ({
  versionMinIos: getMinVersion(displayRequirements, IOS_PLATFORM),
  versionMinAndroid: getMinVersion(displayRequirements, ANDROID_PLATFORM),
})

// строкой JSON, пустой список означает отсутствие требований
export const buildDisplayRequirements = (
  versionMinIos: string,
  versionMinAndroid: string,
) => {
  const clientVersions = [
    { platform: IOS_PLATFORM, minValue: versionMinIos?.trim() ?? '' },
    { platform: ANDROID_PLATFORM, minValue: versionMinAndroid?.trim() ?? '' },
  ].filter((clientVersion) => clientVersion.minValue !== '')

  return clientVersions.length ? JSON.stringify({ clientVersions }) : null
}

// Маска версии: только цифры и точки, максимум три сегмента
export const formatVersionInput = (value: string) =>
  value
    .replace(/[^\d.]/g, '')
    .replace(/\.{2,}/g, '.')
    .replace(/^\./, '')
    .split('.')
    .slice(0, 3)
    .join('.')

export const isVersionInvalid = (value: string) =>
  value?.trim() !== '' && !/^\d+\.\d+\.\d+$/.test(value?.trim() ?? '')
